import { MarketingShell } from "@/components/landing/MarketingShell";
import { Features } from "@/components/landing/Features";
import { SeoHead } from "@/components/useSeo";

const Page = () => (
  <MarketingShell>
    <SeoHead
      path="product-features"
      title="Features — DollarDeploy"
      description="Everything you need to deploy and manage apps on your own servers — without touching the terminal."
    />
    <section className="container py-20">
      <Features />
    </section>
  </MarketingShell>
);

export default Page;
